import { components } from "@certn/api/generated-schemas/client-portal";
import { showToast } from "@certn/cascadia";
import {
  Divider,
  ExpandableCard,
  Icon,
  LinkButton,
  Stack,
  Text,
  TextField,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function PackageInfo({
  packageData,
  expanded,
}: {
  packageData: components["schemas"]["AtsIntegrationPackageList"];
  expanded?: boolean;
}) {
  const { t } = useTranslation();

  function copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    showToast(t("Reference copied to clipboard"), { type: "success" });
  }

  return (
    <ExpandableCard
      expanded={expanded}
      title={
        <>
          <Icon name="package_2" />
          {packageData.name}
        </>
      }
    >
      <div style={{ margin: "var(--space-4)" }}>
        <Stack gap="space-4">
          <Stack orientation="horizontal" align="end" gap="space-2">
            <Text color="text-weak">
              {t("Reference ID")}: {packageData.reference}
            </Text>
            <LinkButton
              testID="copy-package-reference"
              textColor="text-weak"
              leftIcon="content_copy"
              leftIconType="standard"
              onClick={() => copyToClipboard(packageData.reference)}
            />
          </Stack>
          {packageData.packagecheck_set.map(
            ({ check_name, check_reference, check_type }, idx) => (
              <Stack key={idx} gap="space-4" style={{ margin: 4 }}>
                {idx > 0 && <Divider />}
                <Text style="global/heading-medium">{check_name}</Text>
                <TextField
                  testID="check-certn-reference"
                  label={t("Certn reference")}
                  value={check_type}
                  isDisabled
                  isRequired
                  iconRight="content_copy"
                  iconRightType="standard"
                  onRightIconClick={() => copyToClipboard(check_type)}
                />
                <TextField
                  testID="check-workday-reference"
                  label={t("Workday reference")}
                  value={check_reference}
                  isDisabled
                  isRequired
                  iconRight="content_copy"
                  iconRightType="standard"
                  onRightIconClick={() => copyToClipboard(check_reference)}
                />
              </Stack>
            )
          )}
        </Stack>
      </div>
    </ExpandableCard>
  );
}
